export var LocationProviderType;
(function (LocationProviderType) {
    LocationProviderType["AWS"] = "aws";
    LocationProviderType["Azure"] = "azure";
})(LocationProviderType || (LocationProviderType = {}));
;
